<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12" class="pt-0">
      <v-row justify="space-between">
        <v-col cols="6">
          <h1>Клиенты</h1>
        </v-col>
        <v-col cols="3" class="search-col">
          <v-text-field
                  v-model="search"
                  prepend-icon="mdi-magnify"
                  label="Поиск"
                  single-line
                  otlined
                  hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3" class="" style="min-height: 60px;">
          <template v-if="selected.length > 0">
          <v-btn class="mr-3" :disabled="selected.length === 0" outlined>Выбрано: {{ selected.length }}</v-btn>
          
          </template>
        </v-col>
        <v-col cols="12" sm="9" >
          <v-slide-group class="text-right">
            <v-slide-item v-if="filters.app.value ">
              <v-chip
                  class="v-btn ml-3"
                  close
                  @click:close="filters.app.value = null"
                  color="#FAFCFF"
                  outlined
                  label
                  text-color="currentColor"
              >
                {{ filters.app.value }}
              </v-chip>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет клиентов"
              no-results-text="По заданному запросу ничего не найдено"
              v-model="selected"
              :headers="headers"
              :items="users"
              :search="search"
              :options.sync="options"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :server-items-length="totalUsers"
              :loading="loading"
              :items-per-page="15"
              loading-text="Загрузка клиентов... Подождите пожалуйста"
              show-select
      >
        <template v-slot:header.first_open_app>
          Приложение<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.app.value}"
                 @click.stop.prevent="filters.app.modal = !filters.app.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:item.orders_sum="{ item }">
          {{ item.orders_sum }} UAH
        </template>
        <template v-slot:item.first_open_app="{ item }">
          <v-checkbox v-model="item.first_open_app" disabled :label="item.app_version" dense class="mt-0 pt-0"></v-checkbox>
        </template>
       
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click.stop="$router.push({ name: 'user-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
  
    <v-dialog
        v-model="filters.app.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
              label="Источник"
              :items="apps"
              v-model="filters.app.tempValue"
              outlined>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setAppFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.app.modal = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import UserService from './../../api/UserService'
  import PromocodeService from "../../api/PromocodeService";

  export default {
    name: 'UserIndex',
    components: {},
    data: () => ({
      tab: 1,
      loadingButton: false,
      massTagDialog: false,
      massSelectedTag: {},
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      selected: [],
      apps: ['Android', 'IOS', 'Есть приложение', 'Без приложения'],
      filters: {
        app: {
          value: '',
          tempValue: '',
          modal: false,
        },
      },
      overlay: false,
      search: '',
      loading: true,
      tags: [],
      currentPromocode: null,
      promocodes: [],
      options: {},
      footerProps: {
        itemsPerPageText: 'Блюд на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [15, 30]
      },
      totalUsers: 0,
      headers: [
        {
          text: 'ID',
          value: 'id',
          sortable: false
        },
        {
          text: 'Телефон',
          value: 'phone',
          sortable: false
        },
        {
          text: 'Клиент',
          value: 'name',
        },
        {
          text: 'Основной адрес',
          value: 'main_address.address',
        },
        {
          text: 'Приложение',
          value: 'first_open_app',
          sortable: false,
        },
        {
          text: 'День рождения',
          value: 'birthday',
        },
        {
          text: 'Сумма заказов',
          value: 'orders_sum',
        },
         
        {
          text: 'Кол-во заказов',
          value: 'orders_count',
        },
        {
          text: 'Последний заказ',
          value: 'last_order_at',
        },
        {
          text: 'Комментарий',
          value: 'comment',
          sortable: false
        },
        {
          value: 'actions',
          sortable: false,
          width: "5%"
        },
      ],
      users: [],
      categories: [],
    }),
    mounted() {
      let params = {
        available: true
      }
      PromocodeService.list(params).then(response => {
        this.promocodes = response.data
      })
    },
    watch: {
      options: {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      search() {
        clearTimeout(this.timerId)
        this.timerId = setTimeout(() => {
          this.getDataFromApi()
        }, 700)
      },
      "filters.app.value": {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    methods: {
      setAppFilter(e) {
        this.filters.app.value = this.filters.app.tempValue
        this.filters.app.modal = false;
      },
    
      collectSelectedId(){
        let ids = [];
        this.selected.forEach(function (item) {
          ids.push(item.id)
        })

        return ids;
      },
      removeUser(item){
        this.loading = true;
          UserService.remove(item.id).then(response => {
            this.getDataFromApi()
          })
      },
      getDataFromApi() {
        this.loading = true
        this.selected = [];
        let params = {
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
          sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
          app: this.filters.app.value,
          search: this.search,
        }
        UserService.list(params)
          .then(response => {
            this.users = response.data.data
            this.totalUsers = response.data.total
            this.loading = false
          })
      },
    }
  }
</script>


<style lang="scss" scoped>
::v-deep{
  table .v-input:not(.disabled) .v-input__slot{
    background-color: transparent;
  }
}
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
